module.exports = __webpack_public_path__ + "static/img/paypal-logo.870678b6.jpg";